// Navegador interno (WebView) do Facebook/Instagram no Android. O Google pode
// bloquear o login OAuth nele (erro 403 disallowed_useragent). No iPhone o
// login funciona (testado em out/2026), então só o Android é sinalizado.
//   Facebook Android:  "...; wv) ... [FB_IAB/FB4A;FBAV/...]"
//   Instagram Android: "...; wv) ... Instagram 352.0.0.40.98 Android (...)"
export function ehNavegadorInternoMetaAndroid(userAgent) {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  if (!/Android/i.test(ua || '')) return false;
  if (/FB_IAB|FBAV/.test(ua)) return true;
  return /Instagram/.test(ua) && /\bwv\b/.test(ua);
}
